import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";

export const SidebarContainer = styled.div`
  display: flex;
  height: 20px;

  color: #e1e9fc;
  justify-content: space-between;
  align-items: center;
  padding: 6px;

  list-style: none;
  font-size: 14px;
  font-weight: 700;

  user-select: none;
 
  &:hover {
    cursor: pointer;
  }

  .sidebar-image-div {
    display: flex;
    align-items: center;
  }

  .icon-div {
    display: flex;
  }
`;

export const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const fadeIn = keyframes`
  from {
    height: 0px;
  }

  to {
    height: 10px;
  }
`;

export const LabelLink = styled(Link)`
  display: flex;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  align-items: center;
  text-decoration: none;
  color: #e1e9fc;
  user-select: none;
  
  &:hover {
    cursor: pointer;
    user-select: none;
  }
  
`;

export const DropdownLink = styled(Link)`
  display: flex;
  margin-left: 21px;
  
  align-items: center;
  text-decoration: none;
  color: #f5f5f5;
  
  font-size: 12px;
  font-weight: 400;
  
  user-select: none;
  
  &:hover {
    cursor: pointer;
    user-select: none;
  }

    animation: ${fadeIn} .2s linear;
    transition: display .2s linear;
  
`;